export const HISTORY_CAP = 50;

export const appendHistory = <T>(prev: T[], entry: T, cap = HISTORY_CAP): T[] => {
  const next = [...prev, entry];
  return next.slice(Math.max(0, next.length - cap));
};

export const markAllViewed = <T extends { viewed?: boolean }>(list: T[]): T[] => list.map((item) => ({ ...item, viewed: true }));

export const clearHistory = (): never[] => [];
